import { useNavigate } from 'react-router-dom';
import { useAuthentication } from '../../../context/AuthContext';
import { NavLinkStyled, NavLinksContainer, StyledToolbar } from '../Header';
import { Button, Typography } from '@mui/material';
import { isUserLoggedIn } from '../../../context/AuthHelper';
import PrivateHeader from './PrivateHeader';
import logo from './../../../assets/images/logo/logo.svg';
import { PUBLIC_PAGES } from '../../../lib/constants/routes';
import React from 'react';

interface DesktopHeaderProp {
	unreadMessage: number;
}
function DesktopHeader({ unreadMessage }: DesktopHeaderProp) {
	const { logout, authenticatedData } = useAuthentication();
	const navigate = useNavigate();

	return (
		<>
			<StyledToolbar>
					{/* Logo */}
					<Typography variant="h6" noWrap>
						<img src={logo} alt="logo" style={{ position: 'absolute', height: '85px', top: '24px', left: '60px' }} />
					</Typography>

					{/* Nav Links */}
					<NavLinksContainer>
						{PUBLIC_PAGES.filter((ele) => ele.display === 'true').map((ele, i) => (
							<NavLinkStyled key={i} to={ele.url}>
								{ele.name}
							</NavLinkStyled>
						))}
					</NavLinksContainer>

					{!isUserLoggedIn() && (
						<Button variant="contained" onClick={() => navigate('/login')}>
							Login
						</Button>
					)}
			</StyledToolbar>
			{isUserLoggedIn() && <PrivateHeader {...{ logout, authenticatedData, unreadMessage }} />}
		</>
	);
}

export default DesktopHeader;
